import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import mixpanelService from "./mixpanelService";
import mixpanelEvents, { getScreenName } from "../../config/mixpanelEvents";
import { getTrafficSourceInfo, getQueryParams, TrafficSourceInfo, getPageTypeForExport } from "./trafficSource";

declare var mixpanel: any;

const MixpanelPageTracker = () => {
  const location = useLocation();
  const lastPathnameRef = useRef<string>("");
  const trafficSourceRef = useRef<TrafficSourceInfo | null>(null);
  const superPropsRegisteredRef = useRef<boolean>(false);
  const firstLandingPageRef = useRef<string>("");

  useEffect(() => {
    if (superPropsRegisteredRef.current) return;
    superPropsRegisteredRef.current = true;

    try {
      const trafficInfo = getTrafficSourceInfo(location.pathname);
      trafficSourceRef.current = trafficInfo;

      const firstLandingPage = window.location.origin + location.pathname + location.search;
      firstLandingPageRef.current = firstLandingPage;
      const urlParams = new URLSearchParams(location.search);

      if (typeof mixpanel !== "undefined") {
        mixpanel.register({
    
          channel: "website",
          
          utm_source: urlParams.get("utm_source"),
          utm_medium: urlParams.get("utm_medium"),
          utm_campaign: urlParams.get("utm_campaign"),
          utm_content: urlParams.get("utm_content"),
          utm_term: urlParams.get("utm_term"),
          referrer_domain: trafficInfo.referrer_domain,
          device_type: trafficInfo.device_type,
          browser: trafficInfo.browser,
          os: trafficInfo.os,
          user_status: trafficInfo.user_type,
          geo_state: trafficInfo.region,
          geo_city: trafficInfo.region,
          session_id: trafficInfo.session_id,
          user_id: trafficInfo.user_id,
        });

        if (!sessionStorage.getItem("mp_session_tracked")) {
          sessionStorage.setItem("mp_session_tracked", "true");
          mixpanel.people.set({
            channel: "website",
            utm_source: urlParams.get("utm_source"),
            utm_medium: urlParams.get("utm_medium"),
            utm_campaign: urlParams.get("utm_campaign"),
            utm_content: urlParams.get("utm_content"),
            utm_term: urlParams.get("utm_term"),
            referrer_domain: trafficInfo.referrer_domain,
            device_type: trafficInfo.device_type,
            browser: trafficInfo.browser,
            os: trafficInfo.os,
            user_status: trafficInfo.user_type,
            geo_state: trafficInfo.region,
            geo_city: trafficInfo.region,
            session_id: trafficInfo.session_id,
            user_id: trafficInfo.user_id,
          });
        }
      }
    } catch (e) {
      console.error("mixpanel super props registration failed", e);
    }
  }, []);


  useEffect(() => {
    try {
      if (location.pathname === lastPathnameRef.current) return;
      lastPathnameRef.current = location.pathname;

      const trafficInfo = trafficSourceRef.current || getTrafficSourceInfo(location.pathname);

      const screen_name = getScreenName(location.pathname);
      if (!screen_name) return;

      const currentUrl = window.location.origin + location.pathname + location.search;

      mixpanelService({
        event: mixpanelEvents.SCREEN_LOAD,
        screen_name,
      
        page_path: location.pathname,
        page_category: getPageTypeForExport(location.pathname),
        page_url: currentUrl,
        landing_page: firstLandingPageRef.current,
        referrer_domain: trafficInfo.referrer_domain,
       
        ...getQueryParams(location.search),
       
      });
    } catch (e) {
      console.error("mixpanel screen_load failed", e);
    }
  }, [location.pathname]);

  return null;
};

export default MixpanelPageTracker;
